// @flow

import * as React from 'react';
import moment from 'moment';
import { getComputerDateString, getLocalTimezoneAbbr, type DateLike } from 'app/lib/date';

type Props = {
  time: ?DateLike,
  utc: ?boolean,
  onClick?: ?(SyntheticMouseEvent<HTMLElement>) => void
};

export default class JobLogOutputTimestamp extends React.PureComponent<Props> {
  handleClick = (evt: SyntheticMouseEvent<HTMLTableCellElement>) => {
    evt.preventDefault();

    if (this.props.onClick) {
      this.props.onClick(evt);
    }
  }

  render() {
    let formatted;
    if (this.props.time) {
      if (this.props.utc) {
        formatted = getComputerDateString(moment.utc(this.props.time)) + " UTC";
      } else {
        formatted = getComputerDateString(moment(this.props.time)) + " " + (getLocalTimezoneAbbr() || "");
      }
    }

    const className = (
      this.props.utc
        ? "JobLogOutputComponent__Timestamp JobLogOutputComponent__Timestamp--UTC"
        : "JobLogOutputComponent__Timestamp"
    );

    return (
      <td
        className={className}
        onClick={this.handleClick}
      >
        {formatted}
      </td>
    );
  }
}
